import type { Entitlements } from '@tandemone/types'
import { NO_ENTITLEMENTS } from '@tandemone/types'

import { useSetupState } from '@/domains/setup'

/* deny-by-default while setup is still loading. */
export function useEntitlements(): Entitlements {
  return useSetupState().setupState?.entitlements ?? NO_ENTITLEMENTS
}
